/**
 * DurumSayaclari.jsx — liste satırlarındaki "bekleyen / revizyon / onaylı / reddedilmiş" sayaçları (backlog #283).
 *
 * Bundan önce dört ayrı kopya vardı (PersonelSayacStack, FileStatusIndicator, ProjeSayacStack, TalepStatusStack): ikon + renkli
 * rakam, sıfırlar da basılıyordu. Hepsi artık bu bileşeni çağırır: küçük, renkli, yuvarlatılmış KARELER, içinde yalnızca rakam.
 *
 *   · Sıfır (ya da boş) değer ÇİZİLMEZ; kalanlar `items` sırasıyla yan yana dizilir, sağa yaslı (Detaylar düğmesine bitişik).
 *   · Hepsi sıfırsa hiçbir şey çizilmez ama genişlik KORUNUR (`reserve`), böylece soldaki/sağdaki öğeler satırdan satıra
 *     kaymaz. Başlıkta olduğu gibi yer ayırmak istenmeyen yerde `reserve={false}`.
 *   · `href` verilen kare YENİ SEKMEDE açılan gerçek bir bağlantıdır (ctrl / orta tuş çalışır, StatusTile ile aynı sözleşme);
 *     yoksa `onClick`, o da yoksa düz kare. Anlam renkte ve başlıkta (`label`); lejantı PersonelLegendButton'da.
 *
 * Renkler StandPills'in STATUS_HEX paletinden: warning bekleyen, info revizyon, success onaylı, danger reddedilmiş.
 */
import React from "react";
import { statusBackground } from "../Projects/StandPills";

export const SAYAC_KUTU = 24;
const ARALIK = 4;

const kutuStili = (tone) => ({
  minWidth: SAYAC_KUTU, height: SAYAC_KUTU, padding: "0 6px",
  background: statusBackground(tone), color: "#fff", fontSize: "0.75rem", fontWeight: 600, lineHeight: 1,
});
const kutuSinifi = "d-inline-flex align-items-center justify-content-center rounded-2 flex-shrink-0";

/** Tek sayaç karesi — sıfır kontrolü yapmaz (lejant örneği de bunu kullanır); kontrolü DurumSayaclari yapar. */
export function SayacKutusu({ tone, value, label, href, onClick }) {
  const ortak = { title: label, "aria-label": `${label}: ${value}`, style: kutuStili(tone) };
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={`${kutuSinifi} text-decoration-none`} {...ortak}>
        {value}
      </a>
    );
  }
  if (typeof onClick === "function") {
    return (
      <span
        role="button" tabIndex={0} className={kutuSinifi} {...ortak}
        style={{ ...ortak.style, cursor: "pointer" }}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(e); }
        }}
      >
        {value}
      </span>
    );
  }
  return <span className={kutuSinifi} {...ortak}>{value}</span>;
}

/**
 * @param items    [{ key, tone: "warning"|"info"|"success"|"danger", value, label, href?, onClick? }] — SIRA kalıcıdır
 *                 (bekleyen, revizyon, onaylı, reddedilmiş); `label` çevrilmiş başlık
 * @param reserve  hepsi sıfırken de tam genişliği tut (varsayılan açık)
 */
export default function DurumSayaclari({ items, reserve = true, className = "" }) {
  const gorunen = items.filter((i) => Number(i.value) > 0);
  const tamGenislik = items.length * SAYAC_KUTU + Math.max(items.length - 1, 0) * ARALIK;
  if (gorunen.length === 0) {
    return reserve ? <div aria-hidden="true" className="flex-shrink-0" style={{ width: tamGenislik }} /> : null;
  }
  return (
    <div
      className={`d-flex align-items-center justify-content-end flex-shrink-0 ${className}`}
      style={{ gap: ARALIK, minWidth: reserve ? tamGenislik : undefined }}
    >
      {gorunen.map((i) => (
        <SayacKutusu key={i.key} tone={i.tone} value={i.value} label={i.label} href={i.href} onClick={i.onClick} />
      ))}
    </div>
  );
}
